import type { ReactNode } from 'react';

import Brand from '../Brand';
import LanguageSwitcher from '../LanguageSwitcher';

interface MinimalHeaderMobileProps {
  rightContent?: ReactNode;
  showLanguageSwitcher?: boolean;
  variant?: 'default' | 'compact';
}

const MinimalHeaderMobile = ({
  rightContent,
  showLanguageSwitcher = true,
  variant = 'default',
}: MinimalHeaderMobileProps) => {
  const isCompact = variant === 'compact';

  return (
    <header className="w-full overflow-hidden bg-surface-card px-5 py-4 shadow-sm">
      <div className="flex max-w-full items-center justify-between">
        <Brand link="/" variant="dark" showText={!isCompact} />
        <div className={`flex items-center ${isCompact ? 'gap-3' : 'gap-4'}`}>
          {rightContent}
          {showLanguageSwitcher && (
            <LanguageSwitcher variant={isCompact ? 'compact' : 'dark'} />
          )}
        </div>
      </div>
    </header>
  );
};

export default MinimalHeaderMobile;
